import React from 'react';

// import Header from '../component/common/Header';
// import LoginSection from '../component/home/LoginSection';
// import Footer from '../component/common/Footer';

import CONSTANT from './../../constant';

class Home extends React.Component<any, any>{
    componentDidMount() {
        document.title = CONSTANT.pageTitle.fourZeroFour;
    }

    render() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-4 offset-md-4">
                        <div className="card mt-5">
                            <div className="card-header">
                                404
                            </div>
                            <div className="card-body">
                                Page you are looking for either does not exists or is still under active development. Click <a className="c-pointer text-underline" onClick={() => window.history.go(-1)}>here to go back</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}

export default Home;